import "../../../chunk-PKUHTIDK.js";
const isNull = (object) => object === null;
var isNull_default = isNull;
export {
  isNull_default as default
};
